import type { Chapter } from '../../shared/types';
import { CHAPTERS_META } from '../../shared/chapters';

// Kurzbeschreibungen (deutsch); Anzeigetexte kommen aus i18n
// (chapter_<id>_title / chapter_<id>_desc), dies ist der Fallback.
const DESCRIPTIONS: Record<number, string> = {
  1: 'Schilderwald verstehen',
  2: 'Wer darf zuerst?',
  3: 'Richtungswechsel sicher meistern',
  4: 'Nicht zu schnell, nicht zu nah',
  5: 'Sicher vorbei',
  6: 'Verhalten bei hohem Tempo',
  7: 'Richtig reagieren im Ernstfall',
  8: 'Sehen und gesehen werden',
  9: 'Alkohol, Drogen, Müdigkeit',
  10: 'Spritsparend fahren',
  11: 'Wie das Auto funktioniert',
  12: 'Wo darf ich stehen?',
  13: 'Kinder, Senioren, Radfahrer',
  14: 'Defensiv und vorausschauend',
  15: 'Sicher über die Gleise',
  16: 'Punkte, Probezeit, Papiere',
};

export const CHAPTERS: Chapter[] = CHAPTERS_META.map((m) => ({
  id: m.id,
  title: m.titleDe,
  description: DESCRIPTIONS[m.id] || '',
  videoPlaceholder: `https://picsum.photos/600/${299 + m.id}`,
}));
